import { Button, Typography } from "@material-ui/core";
import Grid from "@material-ui/core/Grid";
import { QRCodeCanvas } from "qrcode.react";
import React, { useRef } from "react";
import { useDispatch } from "react-redux";
import generatePDF, { Resolution } from "react-to-pdf";
import { showPopupSnackbar } from "../../redux/actions/snackbarActions";
import { getToken, requestErrorHandler } from "../../Utils/Common";
import EnvSettings from "../../Utils/EnvSettings";

const server = EnvSettings.server;

export default function QRGeneratorView({ value, labeldata }) {
  const dispatch = useDispatch();
  const componentRef = useRef();
  const downloadPdf = (val) =>
    generatePDF(
      () => {
        return componentRef.current;
      },
      {
        resolution: Resolution.HIGH,
        page: {
          margin: 2,
          format: [30, 50],
          orientation: "landscape",
        },
        method: val ? "build" : "open",
      }
    );

  const submit = (file) => {
    // if (!orderData) {
    //   return;
    // }
    const data = new FormData();
    data.append("token", getToken());
    var v = file.output("blob");
    v = new File([v], crypto.randomUUID() + ".pdf", {
      type: "application/pdf",
    });
    data.append("files[]", v);
    const requestOptions = {
      method: "POST",
      body: data,
    };
    fetch(server + "/convert_pdf_to_zpl", requestOptions)
      .then((res) => res.json())
      .then((result) => {
        requestErrorHandler(result, dispatch);
        if (result.error) {
          dispatch(showPopupSnackbar(result));
        }
        if (result.file_url) {
          window.location.assign(
            server + "/execute_download/" + result.file_url
          );
        }
      })
      .catch((err) => console.error(err));
  };

  return labeldata ? (
    <Grid container spacing={1}>
      <Grid item xs={12} container>
        <Grid
          container
          ref={componentRef}
          style={{ width: 365, margin: 0, backgroundColor: "#FFF" }}
          direction="row"
          spacing={0}
        >
          <Grid item>
            <QRCodeCanvas
              {...{
                value: value,
                size: 75,
              }}
            />
          </Grid>
          <Grid item>
            {labeldata &&
              Object.keys(labeldata).map(
                (f) =>
                  labeldata[f] && (
                    <Typography
                      style={{ padding: 5, fontSize: 18, fontWeight: "bolder" }}
                    >
                      {f.toUpperCase()}: {labeldata[f]}
                    </Typography>
                  )
              )}
          </Grid>
        </Grid>
      </Grid>
      <Grid item>
        <Button
          variant="contained"
          color="primary"
          onClick={() => {
            downloadPdf().then(() => {});
          }}
        >
          Print as PDF
        </Button>
      </Grid>
      <Grid item>
        <Button
          variant="contained"
          color="primary"
          onClick={() => {
            downloadPdf(true).then((pdf) => {
              if (pdf) {
                submit(pdf);
              }
            });
          }}
        >
          Download .ZPL
        </Button>
      </Grid>
    </Grid>
  ) : null;
}
